import { render } from "./StoreSelector.vue?vue&type=template&id=42138d5a&scoped=true"
import script from "./StoreSelector.vue?vue&type=script&lang=js"
export * from "./StoreSelector.vue?vue&type=script&lang=js"

import "@/styles/global.css?vue&type=style&index=0&lang=css&external"
import "./StoreSelector.vue?vue&type=style&index=1&id=42138d5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42138d5a"]])

export default __exports__